module.exports = __webpack_public_path__ + "img/fj.60620e85.svg";